/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusGrantBatchItem } from './BonusGrantBatchItem';
import {
    BonusGrantBatchItemFromJSON,
    BonusGrantBatchItemFromJSONTyped,
    BonusGrantBatchItemToJSON,
    BonusGrantBatchItemToJSONTyped,
} from './BonusGrantBatchItem';

/**
 * 
 * @export
 * @interface BonusGrantBatchPageVo
 */
export interface BonusGrantBatchPageVo {
    /**
     * 当前页
     * @type {number}
     * @memberof BonusGrantBatchPageVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof BonusGrantBatchPageVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof BonusGrantBatchPageVo
     */
    totalRecord?: number;
    /**
     * 批次列表
     * @type {Array<BonusGrantBatchItem>}
     * @memberof BonusGrantBatchPageVo
     */
    records?: Array<BonusGrantBatchItem>;
}

/**
 * Check if a given object implements the BonusGrantBatchPageVo interface.
 */
export function instanceOfBonusGrantBatchPageVo(value: object): value is BonusGrantBatchPageVo {
    return true;
}

export function BonusGrantBatchPageVoFromJSON(json: any): BonusGrantBatchPageVo {
    return BonusGrantBatchPageVoFromJSONTyped(json, false);
}

export function BonusGrantBatchPageVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusGrantBatchPageVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(BonusGrantBatchItemFromJSON)),
    };
}

export function BonusGrantBatchPageVoToJSON(json: any): BonusGrantBatchPageVo {
    return BonusGrantBatchPageVoToJSONTyped(json, false);
}

export function BonusGrantBatchPageVoToJSONTyped(value?: BonusGrantBatchPageVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(BonusGrantBatchItemToJSON)),
    };
}

